module.exports = __webpack_public_path__ + "img/AUD.6c251250.png";